import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Button, Form } from "react-bootstrap";
import { ImEye, ImEyeBlocked } from "react-icons/im";
// import ActionButton from "../../components/ActionButton";
import { v4 as uuid } from "uuid";
import { useDispatch } from "react-redux";
import { setToken, setUserData } from "../../store/reducers/UserReducer";
import { setIsShowAccountCompleteModal } from "../../store/reducers/MainReducer";
import { makeTitle } from "./../../App";
import ActionButton from "../../componets/ActionButon";
import ApiService from "../../helper/api";
import MainService from "../../helper/mainService";

const buttonSpinnerId = uuid();

export default function Login() {
	const [values, setValues] = useState({
		userName: "",
		password: "",
	});
	const dispatch = useDispatch();
	const navigate = useNavigate();

	const onChange = (event, fieldName) => {
		setValues(values => ({
			...values,
			[fieldName]: event.target.value,
		}));
	};

	const onSubmit = event => {
		event.preventDefault();
		MainService.callApi({
			api: ApiService.accountLogin,
			data: values,
			cb: response => {
				const data = response.data;
				if (!response.data || response.message || response.errors) {
					throw new Error(response.message || "Sorry, something went wrong!");
				}
				if (
					response &&
					response.data &&
					response.data &&
					!response.data.errorDescription
				) {
					dispatch(setToken(response.data));
					navigate("/");
					// setTimeout(() => {
					// 	getCurrentUser();
					// }, 100);
				}
			},
			_finally: () => {},
		});
	};

	// const getCurrentUser = () => {
	// 	MainService.callApi({
	// 		api: ApiService.userCurrent,
	// 		cb: response => {
	// 			if (response && response.data) {
	// 				dispatch(setUserData(response.data));
	// 				navigate("/");
	// 			}
	// 		},
	// 	});
	// };
	return (
		<div>
			<section className="vh-100">
				<div className="container py-5 h-100">
					<div className="row d-flex align-items-center justify-content-center h-100">
						{/* <div className="col-md-8 col-lg-7 col-xl-6">
							<img
								src="https://mdbcdn.b-cdn.net/img/Photos/new-templates/bootstrap-login-form/draw2.svg"
								className="img-fluid"
								alt="Phone image"
							/>
						</div> */}
						<div className="col-md-7 col-lg-5 col-xl-5 offset-xl-1">
							<form onSubmit={onSubmit}>
								<div data-mdb-input-init className="form-outline mb-4">
									<label className="form-label" htmlFor="userName">
										User name
									</label>
									<input
										value={values.userName}
										id="userName"
										className="form-control form-control-lg"
										onChange={event => {
											onChange(event, "userName");
										}}
									/>
								</div>

								<div data-mdb-input-init className="form-outline mb-4">
									<label className="form-label" htmlFor="password">
										Password
									</label>
									<input
										type="password"
										id="password"
										value={values.password}
										className="form-control form-control-lg"
										onChange={event => {
											onChange(event, "password");
										}}
									/>
								</div>
								<button
									type="submit"
									data-mdb-button-init
									data-mdb-ripple-init
									className="btn btn-primary btn-lg btn-block">
									Sign in
								</button>
							</form>
						</div>
					</div>
				</div>
			</section>
		</div>
	);
}
